import { render, staticRenderFns } from "./CompanySeizures.vue?vue&type=template&id=5f600e7d&scoped=true"
import script from "./CompanySeizures.vue?vue&type=script&lang=js"
export * from "./CompanySeizures.vue?vue&type=script&lang=js"
import style0 from "./CompanySeizures.vue?vue&type=style&index=0&id=5f600e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f600e7d",
  null
  
)

export default component.exports